// Captures and Annotations
export const CAPTURE_NOW = "now";

// Training Requests
export const TRAIN_NEW = "new";
export const TRAIN_EXISTING = "existing";
